module.exports = __webpack_public_path__ + "img/caas4m-m@1.c4fd1cd2.webp";